<div class="common-scheduled-follow-ups-grid">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="data()"></grid-content>
</div>